module.exports = __webpack_public_path__ + "img/services-02-landscape.7185c29e.jpg";